import React, { useState, useEffect } from "react";

import {
  Button, Checkbox,  Dialog,
  DialogActions, DialogContent, DialogTitle,
  Slide, CircularProgress, Backdrop,  Paper, Chip,
  Table, TableBody, TableContainer, TableHead, TableRow,
} from "@mui/material";

import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import { useForm, Controller, useWatch } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../provider/app/hooks";
import { obtenerGruposXUsuario , actualizarGruposxUsuario} from "../../service/apiService";

import {
  StyledTableRow,
  StyledTableCell,
  CheckBox, StyleTableSortLabel
} from "../../SXStyle";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function DialogMisGrupos({ open, setOpen, setSnackbar, registroSeleccionado }) {
  
  //todos los grupos
  const grupos = useAppSelector((state) => state.StoreGrupos.data);

  //grupos seleccionados
  const [groupSelected, setSelectedGroup] = useState([]);

  const [openLoader, setOpenLoader] = useState(false);

  const dispatch = useAppDispatch();

  //react-hook-form
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {},
  });



  useEffect(() => {
    if(registroSeleccionado && open)
    {
      obtenerListadoPertenenciaGrupos(registroSeleccionado.id);
    }
  },[registroSeleccionado, open])


  //obtiene los grupos al que pertence el usuario
  const obtenerListadoPertenenciaGrupos = async(id) => {
    try
    {
      setOpenLoader(true);
      const result = await obtenerGruposXUsuario(id);
      if(result.data)
        setSelectedGroup(result.data.grupos)
    } catch (ex) {
      console.log({ ex });
    }
    finally {
      setOpenLoader(false); // Desactiva el loading cuando termina
    }
  }

  //guarda la asignacion de grupos del usuario
  const onSubmit = async () => {
    try
    {

      setOpenLoader(true);

      const cacheUsuario = JSON.parse(localStorage.getItem('sesionIniciada'));
      const usuarioSeleccionado = registroSeleccionado.id;
      const assigned_by = cacheUsuario.id;
      const dataToSend = [];

      groupSelected.map((item) => {
        dataToSend.push({
          user : usuarioSeleccionado,
          group: item.id,
          assigned_by: assigned_by
        })
      })

      const result = await actualizarGruposxUsuario({"user_groups": dataToSend});

      if (result.result)
      {
        setSnackbar({ message: "Los grupos del usuario se sincronizaron con éxito", open: true });
      }
      else
      {
        setSnackbar({ message: "Ocurrió un error , intente de nuevo", open: true });
      }
      
      //handleDialogClose();
    }
    catch(ex)
    {
      setSnackbar({ message: "Ocurrió un error , intente de nuevo", open: true });
    }
    finally {
      setOpenLoader(false); // Desactiva el loading cuando termina
    }
  };

  //selecciona todos los grupos
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setSelectedGroup(grupos);
      return;
    }
    setSelectedGroup([]);
  };


  //selecciona un grupo
  const handleClick = (event, row) => {
    setSelectedGroup((oldArray) => {
      const existe = oldArray.some((item) => item.id === row.id);
      if (existe)
        return oldArray.filter((item) => !(item.id === row.id)); // Elimina si ya existe
      else
        return [...oldArray, row]; // Agrega si no existe
    })
  };

  //cierra el dialog
  const handleDialogClose = () => {
     //limpia los datos despues de mandar una solicitud
    reset();
   
    setOpen(false);
    setSelectedGroup([])
  };


  return (
    <React.Fragment>

      <Dialog
        open={open}
        slots={{
          transition: Transition,
        }}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            width: "100%",
            backgroundColor: "#555b5e",
            border: "1px solid",
            borderRadius: "10px",
            borderColor: "#555b5e",
            maxHeight: "500px"
          },
        }}
      >
        <DialogTitle>
          <div className="flex w-full">
            <p className="text-white font-bold text-sm mt-2 ml-2"> Grupos al que pertenece: {registroSeleccionado?.fullname} </p>
            <div className="ml-auto cursor-pointer"> 
              <ManageHistoryIcon className="text-blanco" sx={{fontSize: "28px" }}/>
            </div>
          </div>
        </DialogTitle>

        <DialogContent>
          <form
            id="mi-formulario"
            className="space-y-4 md:space-y-6"
            onSubmit={handleSubmit(onSubmit)}
          >
            
            {/* Tabla */}
            <div>
              { openLoader ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                  <CircularProgress sx={{ color: "#cc9737" }} />
                </div>
              ) : (
                <TableContainer
                  component={Paper}
                  sx={{  width: "100%", marginTop: "20px" }}
                >
                  <Table aria-label="customized table" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell align="center">
                          <Checkbox
                            color="primary"
                            indeterminate={groupSelected.length > 0 && groupSelected.length < grupos?.length }
                            checked={grupos?.length > 0 && groupSelected.length === grupos?.length }
                            sx={CheckBox}
                            onChange={handleSelectAllClick}
                            inputProps={{
                              'aria-label': 'select all desserts',
                            }}
                          />
                        </StyledTableCell>
                          
                        <StyledTableCell align="left">
                          Nombre 
                        </StyledTableCell>
                    
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {grupos?.map((row, index) => {
                        const isItemSelected = groupSelected?.some(obj => obj.id === row.id);
                        const labelId = `enhanced-table-checkbox-${index}`;
                        return (
                          <StyledTableRow 
                            hover
                            onClick={(event) => handleClick(event, row)}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            key={row.id}
                            sx={{ cursor: 'pointer' }}
                          >
                            <StyledTableCell align="center">
                              <Checkbox
                                color="primary"
                                checked={isItemSelected}
                                sx={{...CheckBox, width: "12px", height: "12px"}}
                                inputProps={{
                                  'aria-labelledby': labelId,
                                }}
                              />
                            </StyledTableCell>

                        
                            <StyledTableCell align="left">
                              <div className="flex">
                                <span className="mr-5"> {row.name}</span> 
                                <Chip label={row.type} color="primary" className="ml-3 mt-[-5px]"/>
                              </div>
                            </StyledTableCell>
                          </StyledTableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </div>

          </form>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleDialogClose}>
            <p className="text-rojo"> Cancelar </p>
          </Button>
          <Button onClick={onSubmit} form="mi-formulario" >
            <p className="text-amarillo"> Aceptar </p>
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default DialogMisGrupos;
